Dataset.modules.form = {
  _checkValidity: function() {
    // summary view gives us no columns; validity is irrelevant in that case anyway.
    this.visibleColumns = this.visibleColumns || [];

    return !_.isEmpty(this.visibleColumns);
  }
};
